

import { useEffect, useState } from "react"
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters"
import "./portfolio.scss"
import Loader from "react-loaders"
import { projects } from "./projectConstants"
import ProjectCard from "../Cards/ProjectCard/ProjectCard"

function Portfolio() {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container portfolio-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={["M", "y", " ", "W", "o", "r", "k", "s"]}
                            idx={15}
                        />
                    </h1>
                </div>
                <div className="project-container">
                    {
                        projects.map((project, idx) => (
                            <ProjectCard
                                key={idx}
                                title={project.title}
                                desc={project.desc}
                                tags={project.tags}
                                link={project.link}
                                gitHubLink={project.gitHubLink}
                                img={project.img}
                            />
                        ))
                    }
                </div>
            </div>
            <Loader type="pacman" />
        </>
    )
}

export default Portfolio